import {get, post} from "@/utils/http";

export const _getSelectPages = params => get("/wechatLoginCode/selectPages", params);
export const getDelay = params => get("/wechatLoginCode/delay", params);
export const getSave = params => post("/wechatLoginCode/save", params);
export const getUpdatePC = params => get("/wechatLoginCode/updatePC", params);
export const getUpdateMiniProgram = params => get("/wechatLoginCode/updateMiniProgram", params);
export const getUpdateStatus = params => get("/wechatLoginCode/updateStatus", params);


